import { config, gameState } from '@js/state';

let points;
let array;
let divide = false;

const fadeOut = false;

let joystickInput = false;

const sliderDrag = false;

export default class TutorialScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'TutorialScene',
    });
  }

  preload() {}

  create() {
    config.audio.hintaudio = this.sound.add('hintaudio').setVolume(0.05);
    config.audio.incorrectdropaudio = this.sound
      .add('incorrectdropaudio')
      .setVolume(0.05);
    config.audio.correctdropaudio = this.sound.add('correctdropaudio').setVolume(0.05);
    config.audio.wrongdivideaudio = this.sound.add('wrongdivideaudio').setVolume(0.05);
    config.audio.correctdivideaudio = this.sound
      .add('correctdivideaudio')
      .setVolume(0.05);
    config.audio.heliaudio = this.sound.add('heliaudio').setVolume(0.005);

    // this.heliaudio.setLoop(true).setVolume(0.02).play();
    //this.heliaudio = this.sound.add("heliaudio").setVolume(0.02);

    //this.heliaudio.play();

    config.audio.ta1 = this.sound.add('ta1').setVolume(0.3);
    config.audio.ta2 = this.sound.add('ta2').setVolume(0.3);
    config.audio.ta3 = this.sound.add('ta3').setVolume(0.3);
    config.audio.ta4 = this.sound.add('ta4').setVolume(0.3);
    config.audio.ta5 = this.sound.add('ta5').setVolume(0.3);
    config.audio.ta6 = this.sound.add('ta6').setVolume(0.3);

    this.add
      .sprite(config.width / 2, config.height / 2, 'tutorialSceneBG')
      .setDisplaySize(1280, 720);
    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, 'overlay')
      .setAlpha(0.6)
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setDisplaySize(1280, 720);
    this.numberLine = this.add
      .sprite(config.width / 2, config.height - 127, 'numberLine')
      .setScale(0.668)
      .setFrame(0);
    this.speechBubble = this.add
      .sprite(210, 230, 'speechBubble')
      .setScale(0.67)
      .setAlpha(0)
      .setOrigin(0, 0.1);
    this.qBoard = this.add
      .sprite(210, 250, 'qBoard')
      .setScale(0.67)
      .setOrigin(0, 1)
      .setAlpha(0);
    this.tutSceneText = this.add
      .sprite(config.width / 2, config.height / 2 + 120, 'tutSceneText1')
      .setScale(0.67)
      .setOrigin(0.5, 0.5)
      .setAlpha(0);

    this.heliHover = this.physics.add
      .sprite(-200, 358, 'heliHoverAnim')
      .setScale(0.67)
      .setDepth(1);
    this.anims.create({
      key: 'hover',
      frames: this.anims.generateFrameNames('heliHoverAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.anims.create({
      key: 'drop',
      frames: this.anims.generateFrameNames('heliDropAnim', {
        start: 0,
        end: 359,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.heliHover.play('hover');

    this.moveHeli(3000, -200, 642);

    this.time.delayedCall(2500, function () {
      config.audio.ta1.play();
    });

    this.tweens.add({
      targets: this.speechBubble,
      ease: 'Quint.easeInOut',
      duration: 800,
      delay: 2500,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      scale: {
        getStart: () => 0,
        getEnd: () => 0.67,
      },
      yoyo: true,
      hold: 2000,
      loop: 0,
    });

    this.qBoardAppear(210, 6000, 0, 1, 0, 0.67);

    //this.textAppearAnim(7800);

    this.time.delayedCall(
      7800,
      () => {
        this.tutSceneText.setAlpha(1);
      },
      this,
    );

    this.time.delayedCall(8000, function () {
      config.audio.ta2.play();
    });

    this.time.delayedCall(
      11800,
      function () {
        //this.tutSceneText.setTexture("tutSceneText2");
        this.textDisappear(0);
      },
      [],
      this,
    );
    this.time.delayedCall(13000, function () {
      config.audio.ta3.play();
    });

    this.time.delayedCall(
      12800,
      () => {
        this.tutSceneText.setTexture('tutSceneText2').setAlpha(1);
      },
      this,
    );

    //this.textAppearAnim(12800);

    this.sliderBar = this.add
      .sprite(config.width / 2 - 60, 800, 'sliderBar')
      .setScale(0.67);

    this.sliderButtonGhost = this.add
      .sprite(config.width / 2 - 155, 800, 'sliderButton')
      .setScale(0.67)
      .setAlpha(0.6);

    this.sliderButton = this.add
      .sprite(config.width / 2 - 155, 800, 'sliderButton')
      .setScale(0.67)
      .setInteractive({
        cursor: 'pointer',
      });

    this.handIcon = this.add
      .sprite(config.width / 2 - 140, 680, 'handIcon')
      .setScale(0.67)
      .setVisible(false);

    this.checkButton = this.add
      .sprite(config.width / 2 + 150, 800, 'checkButtonAnim')
      .setScale(0.67)
      .setInteractive({
        cursor: 'pointer',
        pixelPerfect: true,
      });

    this.checkButton.disableInteractive();

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('checkButtonAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'CHECK BREATHING',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.checkConfetti = this.add.sprite(
      config.width / 2 + 150,
      680,
      'checkConfettiAnim',
    );
    this.anims.create({
      key: 'confetti',
      frames: this.anims.generateFrameNames('checkConfettiAnim', {
        start: 0,
        end: 47,
        zeroPad: 0,
        prefix: 'checkconfetti',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.checkButtonRight = this.add
      .sprite(config.width / 2 + 150, 650, 'checkRightAnim')
      .setScale(0.67)
      .setVisible(false);

    this.anims.create({
      key: 'correct',
      frames: this.anims.generateFrameNames('checkRightAnim', {
        start: 1,
        end: 32,
        zeroPad: 0,
        prefix: 'CHECK RIGHT',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.tweens.add({
      targets: [
        this.sliderBar,
        this.sliderButton,
        this.checkButton,
        this.sliderText,
        this.sliderButtonGhost,
      ],
      ease: 'Sine.easeInOut',
      duration: 800,
      delay: 13200,
      y: {
        getStart: () => 800,
        getEnd: () => 650,
      },
      yoyo: false,
      loop: 0,
      onComplete: () => {
        this.handIcon.setVisible(true);
        this.handAnim.play();
        this.arrows.setVisible(true);
        this.arrowAnim.play();
      },
    });

    this.arrows = this.add
      .sprite(config.width / 2 - 30, 650, 'arrows')
      .setVisible(false)
      .setScale(0.67);

    this.handAnim = this.tweens.add({
      targets: [this.handIcon, this.sliderButtonGhost],
      ease: 'Power2',
      duration: 1000,
      x: {
        getStart: () => 485,
        getEnd: () => 485 + 190,
      },
      yoyo: false,
      loop: -1,
      paused: true,
    });

    this.arrowAnim = this.tweens.add({
      targets: this.arrows,
      ease: 'Power1',
      duration: 1000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      loop: -1,
      paused: true,
    });

    this.sliderButton.drag = this.plugins.get('rexdragplugin').add(this.sliderButton, {
      axis: 'h',
    });

    this.sliderButton.drag.drag();

    this.sliderText = this.add
      .text(this.sliderButton.x, this.sliderButton.y, gameState.value, {
        fontFamily: 'font1',
        fontSize: '20px',
        fill: '000000',
      })
      .setOrigin(0.5, 0.5);

    this.sliderButton.on(
      'drag',
      function (pointer, dragX, dragY) {
        if (this.sliderButton.x > 490) {
          this.handAnim.stop();
          this.sliderButtonGhost.destroy();
          this.handIcon.destroy();
          this.arrowAnim.stop();
          this.arrows.destroy();
          this.sliderButton.x = 637;
          this.checkButton.setInteractive();
          gameState.value = 8;
          this.numberLineDivide(8);
          this.sliderButton.drag.setEnable(false);

          this.checkButton.play('breathe');
          this.textDisappear(0);
          this.time.delayedCall(
            600,
            () => {
              this.tutSceneText.setTexture('tutSceneText3').setAlpha(1);
            },
            this,
          );

          this.time.delayedCall(1000, function () {
            config.audio.ta4.play();
          });

          //this.textAppearAnim(500);
        }
      },
      this,
    );

    this.leftButton = this.add.sprite(494, 800, 'leftButton').setScale(0.67);

    this.anims.create({
      key: 'leftpress',
      frames: this.anims.generateFrameNames('leftButton', {
        start: 1,
        end: 2,
        zeroPad: 0,
        prefix: 'leftButton',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.rightButton = this.add.sprite(575, 800, 'rightButton').setScale(0.67);

    this.anims.create({
      key: 'rightpress',
      frames: this.anims.generateFrameNames('rightButton', {
        start: 1,
        end: 2,
        zeroPad: 0,
        prefix: 'rightButton',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dropButton = this.add
      .sprite(config.width / 2 + 80, 800, 'dropButtonAnim')
      .setScale(0.67);

    this.anims.create({
      key: 'breatheDrop',
      frames: this.anims.generateFrameNames('dropButtonAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'DROP Button breathig',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    //code for creating line on which we will create the dots.

    this.graphics = this.add.graphics();

    this.curve = new Phaser.Curves.Line(
      new Phaser.Math.Vector2(185, 576),
      new Phaser.Math.Vector2(1098, 576),
    );

    this.linePoints = this.add.group();

    this.curve.draw(this.graphics);

    this.checkButton.on(
      'pointerover',
      function (pointer) {
        this.checkButton.setTint(0xc4c4c4);
      },
      this,
    );

    this.checkButton.on(
      'pointerout',
      function (pointer) {
        this.checkButton.setTint();
      },
      this,
    );

    this.checkButton.on(
      'pointerup',
      function (pointer) {
        config.audio.correctdivideaudio.play();
        this.checkButton.stop('breathe');

        this.checkButton.setVisible(false);
        this.checkButtonRight.setVisible(true);

        this.checkButtonRight.play('correct');

        this.checkConfetti.play('confetti');

        this.numberLine.setFrame(1);

        array = this.linePoints.getChildren();

        divide = true;

        joystickInput = false;

        array[0].setFrame(2);

        for (let i = 1; i < array.length; i++) {
          array[i].setFrame(2);
        }

        this.time.delayedCall(
          1800,
          function () {
            this.controlsSlideIn([this.leftButton, this.rightButton], 800, 650);
            this.controlsSlideIn([this.dropButton], 800, 650);

            this.textDisappear(0);

            this.time.delayedCall(
              600,
              () => {
                this.tutSceneText.setTexture('tutSceneText4').setAlpha(1);
              },
              this,
            );

            this.time.delayedCall(2000, function () {
              config.audio.ta5.play();
            });

            //this.textAppearAnim(1500);

            for (let i = 0; i < array.length; i++) {
              array[i].setFrame(0);
            }

            this.numberLine.setFrame(0);

            this.sliderBar.destroy();
            this.sliderButton.destroy();
            this.sliderText.setVisible(false);

            this.checkButton.destroy();

            this.checkButtonRight.setVisible(false);

            this.checkButtonRight.setPosition(config.width / 2 + 80, 670);

            //this.moveHeli(2000, 600, 642);

            //this.qBoardAppear(170, 1, 0, 0.67, 0);
          },
          [],
          this,
        );

        this.time.delayedCall(
          2500,
          function () {
            array[0].setFrame(1);

            //this.leftButton.setInteractive({ cursor: "pointer" });
            //this.rightButton.setInteractive({ cursor: "pointer" });
          },
          [],
          this,
        );

        config.audio.ta5.on(
          'complete',
          () => {
            this.rightButton.setInteractive({ cursor: 'pointer' });
          },
          this,
        );
      },
      this,
    );

    // this.leftButton.on(
    //   "pointerover",
    //   () => {
    //     this.leftButton.setTint(0xc4c4c4);
    //   },
    //   this
    // );
    // this.leftButton.on(
    //   "pointerout",
    //   () => {
    //     this.leftButton.setTint();
    //   },
    //   this
    // );

    this.rightButton.on(
      'pointerover',
      () => {
        this.rightButton.setTint(0xc4c4c4);
      },
      this,
    );

    this.rightButton.on(
      'pointerout',
      () => {
        this.rightButton.setTint();
      },
      this,
    );

    this.leftButton.on(
      'pointerdown',
      () => {
        this.rightButton.setTint();
        this.leftButton.play('leftpress');
        this.leftButton.y += 2.68;
      },
      this,
    );

    this.rightButton.on(
      'pointerdown',
      () => {
        this.rightButton.setTint();
        this.textDisappear(0);
        joystickInput = true;
        this.rightButton.play('rightpress');
        this.rightButton.y += 2.68;

        this.qBoard.setAlpha(0);
        this.moveHeli(5000, 642, 1212);

        this.rightButton.on(
          Phaser.Animations.Events.ANIMATION_COMPLETE,
          function () {},
          this,
        );

        this.time.delayedCall(
          800,
          function () {
            this.rightButton.removeInteractive();
          },
          [],
          this,
        );

        this.time.delayedCall(
          5000,
          function () {
            this.qBoardAppear(780, 0, 0, 1, 0, 0.67);
            this.rightButton.y -= 2.68;

            this.rightButton.playReverse('rightpress');
            //this.dropButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            this.dropButton.play('breatheDrop');

            this.tutSceneText.setTexture('tutSceneText5').setAlpha(1);
            this.time.delayedCall(200, function () {
              config.audio.ta6.play();
            });

            config.audio.ta6.on(
              'complete',
              () => {
                this.dropButton.setInteractive({ cursor: 'pointer', pixelPerfect: true });
              },
              this,
            );

            //this.textAppearAnim(0);
          },
          [],
          this,
        );
      },
      this,
    );

    this.dropButton.on(
      'pointerup',
      function (pointer) {
        this.textDisappear(0);
        config.audio.correctdropaudio.play();
        joystickInput = false;
        this.dropButton.stop('breatheDrop');
        this.qBoard.setVisible(false);

        this.dropButton.setVisible(false);

        this.overlay.destroy();

        this.numberLine.setFrame(3);

        for (let i = 0; i < array.length; i++) {
          array[i].setFrame(3);
        }

        array[5].setFrame(2);

        this.checkButtonRight.setPosition(this.dropButton.x, this.dropButton.y);

        this.checkButtonRight.setVisible(true);

        this.checkButtonRight.play('correct');

        this.heliHover.setTexture('heliDropAnim');
        this.heliHover.play('drop');

        this.add.sprite(942.5, 62.5, 'correctCounter').setScale(0.67);

        this.tweens.add({
          targets: this.heliaudio,
          delay: 2000,
          volume: 0,
          duration: 3000,
          onComplete: () => {},
        });

        this.time.delayedCall(
          4000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this,
        );

        this.cameras.main.once(
          'camerafadeoutcomplete',
          function (camera) {
            this.scene.start('GameScene');
          },
          this,
        );
      },
      this,
    );
  }

  /*Custom functions*/

  numberLineDivide(divisions) {
    points = this.curve.getPoints(divisions);
    //console.log(points);

    for (let i = 0; i < points.length; i++) {
      const x = this.add
        .sprite(points[i].x, points[i].y, 'linePoint')
        .setFrame(0)
        .setScale(0.67);
      this.linePoints.add(x);
      //console.log(this.linePoints);
    }
  }

  controlsSlideIn(targets, start, end) {
    this.tweens.add({
      targets: targets,
      ease: 'Sine.easeInOut',
      duration: 800,
      y: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
    });
  }

  moveHeli(durationVal, start, end) {
    this.tweens.add({
      targets: this.heliHover,
      ease: 'Sine.easeInOut',
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
      onStart: () => {
        config.audio.heliaudio.setLoop(true).setVolume(0.005).play();
      },
      onComplete: () => {
        this.tweens.add({
          targets: this.heliaudio,
          ease: 'Linear',
          volume: 0,
          duration: 200,
          onComplete: () => {
            config.audio.heliaudio.stop();
          },
        });
      },
    });
  }

  textAppearAnim(delay) {
    this.tweens.add({
      targets: this.tutSceneText,
      ease: 'Quint.easeInOut',
      duration: 800,
      delay: delay,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      scale: {
        getStart: () => 0,
        getEnd: () => 0.67,
      },
      yoyo: true,
      hold: 2000,
      loop: 0,
    });
  }

  textDisappear(delay) {
    this.tweens.add({
      targets: this.tutSceneText,
      ease: 'Linear',
      duration: 500,
      delay: delay,
      alpha: 0,
    });
  }
  qBoardAppear(newPos, delayVal, alphaStart, alphaEnd, scaleStart, scaleEnd) {
    this.qBoard.x = newPos;

    this.tweens.add({
      targets: this.qBoard,
      ease: 'Quint.easeInOut',
      duration: 800,
      delay: delayVal,
      alpha: {
        getStart: () => alphaStart,
        getEnd: () => alphaEnd,
      },
      scale: {
        getStart: () => scaleStart,
        getEnd: () => scaleEnd,
      },
      yoyo: false,
      loop: 0,
    });
  }

  /*--------------------------------------*/

  update() {
    //console.log(this.heliHover.x);

    this.sliderText.x = this.sliderButton.x + 1;
    this.sliderText.y = this.sliderButton.y + 1.5;

    this.sliderText.setText(gameState.value);

    if (this.sliderButton.x < config.width / 2 - 155) {
      this.sliderButton.x = config.width / 2 - 155;
      this.sliderText.x = config.width / 2 - 155 + 1.4;
    }

    if (this.sliderButton.x > config.width / 2 - 155 + 190) {
      this.sliderButton.x = config.width / 2 - 155 + 190;
      this.sliderText.x = config.width / 2 - 155 + 190 + 1.4;
    }

    if (divide == true && joystickInput == true) {
      if (this.heliHover.x == 642) {
        array[0].setFrame(1);
      } else {
        array[0].setFrame(0);
      }

      if (this.heliHover.x > 746 && this.heliHover.x < 766) {
        array[1].setFrame(1);
      } else {
        array[1].setFrame(0);
      }

      if (this.heliHover.x > 860 && this.heliHover.x < 880) {
        array[2].setFrame(1);
      } else {
        array[2].setFrame(0);
      }

      if (this.heliHover.x > 974 && this.heliHover.x < 994) {
        array[3].setFrame(1);
      } else {
        array[3].setFrame(0);
      }

      if (this.heliHover.x > 1088 && this.heliHover.x < 1108) {
        array[4].setFrame(1);
      } else {
        array[4].setFrame(0);
      }

      if (this.heliHover.x > 1202 && this.heliHover.x < 1222) {
        array[5].setFrame(1);
      } else {
        array[5].setFrame(0);
      }
      if (this.heliHover.x > 1316 && this.heliHover.x < 1346) {
        array[6].setFrame(1);
      } else {
        array[6].setFrame(0);
      }
      if (this.heliHover.x > 1430 && this.heliHover.x < 1450) {
        array[7].setFrame(1);
      } else {
        array[7].setFrame(0);
      }
    }
  }
}
